import { render, staticRenderFns } from "./AccessPolicyValueSelect.vue?vue&type=template&id=06f4e398&"
import script from "./AccessPolicyValueSelect.vue?vue&type=script&lang=ts&"
export * from "./AccessPolicyValueSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports